import {
  createPlugin,
  createRoutableExtension,
} from '@backstage/core-plugin-api';
import { academyRouteRef, contributorExternalRouteRef } from './routes';

export const academyPlugin = createPlugin({
  id: 'academy',
  routes: {
    root: academyRouteRef,
  },
  externalRoutes: {
    contributor: contributorExternalRouteRef,
  },
});

export const AcademyPageComponent = academyPlugin.provide(
  createRoutableExtension({
    name: 'AcademyPage',
    component: () => import('./App').then(m => m.App),
    mountPoint: academyRouteRef,
  }),
);
